import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './AdminUploadModeration.css';

const FILTERS = [
  { key: 'unredacted', label: 'Not yet hidden' },
  { key: 'all', label: 'All uploads' },
  { key: 'public', label: 'Public only' }
];

const formatDate = (value) => {
  if (!value) return '';
  const date = new Date(value);
  return Number.isFinite(date.getTime()) ? date.toLocaleDateString() : '';
};

const AdminUploadModeration = () => {
  const [uploads, setUploads] = useState([]);
  const [counts, setCounts] = useState({ totalUploads: 0, unredactedCount: 0 });
  const [filter, setFilter] = useState('unredacted');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const fetchUploads = async (activeFilter) => {
    setLoading(true);
    setError('');

    try {
      const response = await fetch(`/api/admin/uploads?filter=${encodeURIComponent(activeFilter)}`, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token') || ''}` }
      });
      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Unable to load uploads.');
      }

      setUploads(data.uploads || []);
      setCounts({ totalUploads: data.totalUploads || 0, unredactedCount: data.unredactedCount || 0 });
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUploads(filter);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter]);

  return (
    <div className="admin-moderation">
      <div className="admin-moderation-head">
        <div>
          <Link to="/admin" className="admin-moderation-back">← Admin</Link>
          <h1>Check uploads for personal info</h1>
          <p>
            Find uploads that still show personal info and hide it. Hiding replaces the public
            image but keeps the prices. {counts.unredactedCount} of {counts.totalUploads} uploads
            haven’t had anything hidden yet.
          </p>
        </div>
      </div>

      <div className="admin-moderation-filters" role="group" aria-label="Filter uploads">
        {FILTERS.map(option => (
          <button
            key={option.key}
            type="button"
            className={filter === option.key ? 'active' : ''}
            onClick={() => setFilter(option.key)}
          >
            {option.label}
          </button>
        ))}
      </div>

      {error && <p className="admin-moderation-error">{error}</p>}

      {loading ? (
        <p className="admin-moderation-empty">Loading uploads…</p>
      ) : uploads.length === 0 ? (
        <p className="admin-moderation-empty">No uploads match this filter.</p>
      ) : (
        <div className="admin-moderation-grid">
          {uploads.map(upload => (
            <div key={upload._id} className="admin-moderation-card">
              <Link to={`/bills/${upload._id}`} className="admin-moderation-thumb" title="Open upload details">
                <img src={upload.thumbnailUrl || upload.imageUrl} alt={`${upload.vetHospital || 'Upload'} document`} loading="lazy" />
              </Link>
              <div className="admin-moderation-meta">
                <strong>{upload.vetHospital || 'Unknown hospital'}</strong>
                <span className="admin-moderation-sub">
                  {String(upload.documentType || 'upload')} · {formatDate(upload.billDate)}
                </span>
                <div className="admin-moderation-badges">
                  <span className={`badge ${upload.redactionApplied ? 'ok' : 'warn'}`}>
                    {upload.redactionApplied ? `${upload.redactionBoxCount || 0} hidden` : 'Nothing hidden'}
                  </span>
                  <span className={`badge ${upload.visibility === 'private' ? 'muted' : 'public'}`}>
                    {upload.visibility === 'private' ? 'Private' : 'Public'}
                  </span>
                </div>
                <Link to={`/bills/${upload._id}/privacy`} className="admin-moderation-redact">
                  Hide personal info
                </Link>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default AdminUploadModeration;
